import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  changeFlightsFilter,
  clearFlightsFilter,
  getBiblioGlobusFilterSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights-filters';
import { getIsMobile } from 'src/store/view/selectors';
import { scrollToElement } from 'src/utils/domUtils';
import FlightChangeWarning from './FlightChangeWarning';

const mapStateToProps = (state) => ({
  filterByBiblioGlobus: getBiblioGlobusFilterSelector(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  applyFilters: changeFlightsFilter,
  clearFilters: clearFlightsFilter,
  scrollToFlights: (id) => scrollToElement(id),
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(FlightChangeWarning);
